import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SourceTextCache from '../new/sources/SourceTextCache';
//import VerseTextRenderer from '../html/VerseTextRenderer';
import VersionStore from '../new/versions/VersionStore';
import './SearchResult.css';

export default class SearchResult extends Component {
    static contextTypes = {
        //versions: PropTypes.instanceOf(Map).isRequired,
        versions: PropTypes.instanceOf(VersionStore).isRequired
    }

    static propTypes = {
        result: PropTypes.shape({
            name: PropTypes.string.isRequired,
            versions: PropTypes.arrayOf(PropTypes.shape({
                index: PropTypes.number.isRequired,
                versionIndex: PropTypes.number.isRequired,
                text: PropTypes.string.isRequired
            })).isRequired
        }).isRequired,
        query: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        /*this.verseTextRenderer = new VerseTextRenderer();
        this.verseTextRenderer.setShowInterlinearNumbers(false);
        this.verseTextRenderer.setHighlightText(props.queryText);*/
    }

    onClick() {
        this.props.onClick(this.props.result);
    }

    buildVersionHtml(verseVersion) {
        const version = this.context.versions.getVersion(verseVersion.versionIndex);
        const dummyTextCache = new SourceTextCache();
        dummyTextCache.putVerse(verseVersion.index, new Map([[verseVersion.versionIndex, verseVersion.text]]));
        const html = version.getRenderer().render(verseVersion.index, dummyTextCache, {
            highlightQuery: this.props.query,
            noInterlinearNumbers: true,
            noLexiconLookup: true
        });

        /*const html = versions.reduce((html, version) =>
                html + VerseVersionFormatter.getHtml(this.context.versions.get(version.versionIndex),
                version.text, version.index), '');*/
        /*const html = this.verseTextRenderer.getHtml(version.text, version.index,
                this.context.versions.get(version.versionIndex));*/
        return { __html: html };
    }

    render() {
        const result = this.props.result;
        const version = result.versions[0];
        //const versionCode = this.context.versions.get(version.versionIndex).code;
        /*return (
            <div className="SearchResult">
                <div className="SearchResult_LeftMargin" />
                <div className="SearchResult_Content">
                    <div className="SearchResult_VerseName">{result.name}</div>
                    <div dangerouslySetInnerHTML={this.buildVersionHtml(result.versions)} />
                </div>
            </div>
        );*/
        return (
            <div className="SearchResult" onClick={this.onClick}>
                <div className="SearchResult_LeftMargin" />
                <div className="SearchResult_Content">
                    <span className="SearchResult_VerseName _Default">{result.shortName}</span>
                    <span dangerouslySetInnerHTML={this.buildVersionHtml(version)} />
                </div>
            </div>
        );
    }
}
